<template>
  <div class="FormImages">
    <ImageDrop
      type="ARTICLE_IMAGE" />
  </div>
</template>

<script>
import ImageDrop from '@components/fields/ImageDrop'

export default {
  components: {
    ImageDrop,
  },
}
</script>

<style lang="scss">
.FormImages {
}
</style>
